/* eslint-disable react/no-array-index-key */
import React from 'react';

import {createBeerPages} from 'features/postGenerator/utils/createBeerPages/createBeerPages';
import {useGlobalState} from 'hooks/useGlobalState';
import Slider from 'react-slick';

import Post from '../Post/Post';
import './PostSlider.scss';
import ScaleContent from '../ScaleContent/ScaleContent';

interface IProps {
  setRefs?: React.MutableRefObject<HTMLDivElement[]>;
}

export default function PostSlider({setRefs}: IProps) {
  const {backgroundImage, activeTemplate, postType, isPriceChecked} = useGlobalState((state) => state.postGenerator);
  const {pubBeers} = useGlobalState((state) => state.beersManager);
  const pages = createBeerPages({pubBeers, postType, activeTemplate, isPriceChecked});

  return (
    <>
      <div className="post-slider">
        <Slider speed={300} slidesToShow={1} slidesToScroll={1} arrows={false} infinite={false} swipeToSlide dots>
          {pages.map((data, i) => {
            const isFrontPage = i === 0;
            return (
              <div key={`page-${i}`}>
                <ScaleContent
                  // eslint-disable-next-line react/no-unstable-nested-components
                  content={({styles}) => {
                    return <Post frontPage={isFrontPage} beers={data} style={styles} imageUrl={backgroundImage} />;
                  }}
                />
              </div>
            );
          })}
        </Slider>
      </div>

      {setRefs && (
        <div className="download-post">
          {pages.map((data, i) => {
            const isFrontPage = i === 0;
            return (
              <Post
                imageUrl={backgroundImage}
                key={`download-post-${i}`}
                frontPage={isFrontPage}
                beers={data}
                forwardRef={(el) => {
                  if (el) {
                    setRefs.current[i] = el;
                  }
                }}
              />
            );
          })}
        </div>
      )}
    </>
  );
}
